import Swal from 'sweetalert2';
import validator from 'validator';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheBaseServerGet, callTheBaseServerPost } from './helpers/axiosHelper';

import { byId, Toast } from './helpers/utility';




authHelper.validate();

// checking query params for transition result alert






















const getGamesFun = async () => {


    try {
        const response = await callTheBaseServerGet(`/basic/getGames`);
        axiosResponseHandler(response);
        const res = response.data;




        const gameSelectInput = byId('gameSelectInput');


        if (res.status === 'success') {
            console.log(res);

            const gamesData = res.gamesData;
            let i = 0;





            if (gamesData.length > 0) {




                while (i < gamesData.length) {
                    const { sn, shortName } = gamesData[i];

                    gameSelectInput.innerHTML += ` <option value="${sn}">${shortName}</option>
                    `;
                    i++;
                }
            }

            if (gamesData.length === 0) {


                gameSelectInput.innerHTML += `<option selected value="" disabled>No Data Found</option>`;


            }



        }

    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }
};

getGamesFun();

const getRulesCollections = async () => {


    try {
        const response = await callTheBaseServerGet(`/basic/getRulesCollections`);
        axiosResponseHandler(response);
        const res = response.data;




        const rulesCollectionsSelectInput = byId('rulesCollectionsSelectInput');


        if (res.status === 'success') {
            console.log(res);

            const rulesCollectionsData = res.rulesCollectionsData;
            let i = 0;





            if (rulesCollectionsData.length > 0) {




                while (i < rulesCollectionsData.length) {
                    const { sn, name } = rulesCollectionsData[i];

                    rulesCollectionsSelectInput.innerHTML += ` <option value="${sn}">${name}</option>
                        `;
                    i++;
                }
            }

            if (rulesCollectionsData.length === 0) {


                rulesCollectionsSelectInput.innerHTML += `<option selected value="" disabled>No Data Found</option>`;


            }



        }


    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }

};

getRulesCollections();


const gameSelectInput = byId('gameSelectInput');
const matchTitleInput = byId('matchTitleInput');
const matchScheduleInput = byId('matchScheduleInput');
const prizePoolInput = byId('prizePoolInput');
const perKillInput = byId('perKillInput');
const selectTeamSelectInput = byId('selectTeamSelectInput');
const entryFeesInput = byId('entryFeesInput');
const modeSelectInput = byId('modeSelectInput');
const mapInput = byId('mapInput');
const maxJoiningInput = byId('maxJoiningInput');
const bannerLinkInput = byId('bannerLinkInput');
const prizeDescriptionInput = byId('prizeDescriptionInput');
const rulesCollectionsSelectInput = byId('rulesCollectionsSelectInput');


const addNewMatchSubmitFun = async () => {

    // validation

    if (!(gameSelectInput.value > 0)) {
        Toast.fire({
            icon: 'error',
            title: 'Select game '
        });
        return false;
    }
    if (!validator.isLength(matchTitleInput.value, { min: 3, max: 20 })) {

        Toast.fire({
            icon: 'error',
            title: 'matchTitleInput must have 3+ Characters'
        });

        return false;
    }

    const scheduleTimeStamp = Math.round(new Date(matchScheduleInput.value).getTime() / 1000);

    if (!(scheduleTimeStamp > 1234567890)) {

        Toast.fire({
            icon: 'error',
            title: 'Select valid time'
        });

        return false;
    }

    if (!validator.isInt(prizePoolInput.value + '')) {

        Toast.fire({
            icon: 'error',
            title: 'enter valid prizePoolInput '
        });

        return false;
    }
    if (!validator.isInt(perKillInput.value + '')) {

        Toast.fire({
            icon: 'error',
            title: 'enter valid perKillInput '
        });

        return false;
    }
    if (!validator.isInt(entryFeesInput.value + '')) {

        Toast.fire({
            icon: 'error',
            title: 'enter valid entryFeesInput '
        });

        return false;
    }
    if (!validator.isInt(selectTeamSelectInput.value + '')) {

        Toast.fire({
            icon: 'error',
            title: 'enter valid selectTeamSelectInput '
        });

        return false;
    }


    if (!(modeSelectInput.value === 'TPP' || modeSelectInput.value === 'FPP')) {

        Toast.fire({
            icon: 'error',
            title: 'Select valid modeSelectInput'
        });

        return false;
    }
    if (!validator.isLength(mapInput.value, { min: 0, max: 20 })) {

        Toast.fire({
            icon: 'error',
            title: 'mapInput must have 3+ Characters'
        });

        return false;
    }
    if (!validator.isInt(maxJoiningInput.value + '')) {

        Toast.fire({
            icon: 'error',
            title: 'enter valid maxJoiningInput '
        });

        return false;
    }

    if (!validator.isURL(bannerLinkInput.value)) {

        Toast.fire({
            icon: 'error',
            title: 'bannerLinkInput must have url'
        });

        return false;
    }
    if (!validator.isLength(prizeDescriptionInput.value, { min: 0, max: 100 })) {

        Toast.fire({
            icon: 'error',
            title: 'prizeDescriptionInput must have 3+ Characters'
        });

        return false;
    }
    if (!validator.isInt(rulesCollectionsSelectInput.value + '')) {

        Toast.fire({
            icon: 'error',
            title: 'enter valid rulesCollectionsSelectInput '
        });

        return false;
    }



    const title = matchTitleInput.value;
    const bannerLink = bannerLinkInput.value;
    const gameId = +gameSelectInput.value;
    const rulesCollectionId = +rulesCollectionsSelectInput.value;
    const prizePool = prizePoolInput.value;
    const perKill = perKillInput.value;
    const entryFees = entryFeesInput.value;
    const playersInTeam = +selectTeamSelectInput.value;
    const mode = modeSelectInput.value;
    const map = mapInput.value;
    const maxJoining = +maxJoiningInput.value;
    const prizeDescription = prizeDescriptionInput.value;
    const time = scheduleTimeStamp;

    const formData = {
        title,
        bannerLink,
        gameId,
        rulesCollectionId,
        prizePool,
        perKill,
        entryFees,
        playersInTeam,
        mode,
        map,
        maxJoining,
        prizeDescription,
        time

    };
    console.log(formData);

    try {
        const response =  await callTheBaseServerPost(`/basic/addNewMatch`, { data: formData });
        axiosResponseHandler(response);
        const res = response.data;
        if (res.status === 'success') {
            console.log(res);
    
    
            Swal.fire({
                title: 'Match added',
                icon: 'success',
                showConfirmButton: false,
    
    
                allowOutsideClick: false,
    
    
            });
    
            setTimeout(() => {
                location.href = './getMatches.html';
            }, 3000);
    
    
    
        }
    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }

  

};

const addNewMatchSubmitBtn = byId('addNewMatchSubmitBtn');
addNewMatchSubmitBtn.addEventListener('click', addNewMatchSubmitFun);


